import React from "react";

import { RoundColor } from "./style";

type RoundLegendType = {
  color?: string;
};
const RoundLegend = (props: RoundLegendType) => {
  return <RoundColor color={props.color} />;
};

export default RoundLegend;
